import usersApi from "../../api/users";

export default {
  namespaced: true,
  state: {
    listPage: null
  },
  getters: {
  },
  mutations: {
    setListPage(state, page) {
      state.listPage = page
    }
  },
  actions: {
    searchUsers(context, request) {
      return usersApi.search(request).then(function (response) {
        context.commit('setListPage', response.data)
      });
    }
  },
  modules: {
  }
}